module.exports = __webpack_public_path__ + "static/media/post2.c0035fc3.jpg";